module.exports = __webpack_public_path__ + "17b58f9e92fee73d5fec834e2a23d779.svg";